import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {theme} from '../../styles';
import trackAnalytics from '../../utils/gaia/trackAnalytics';

export default class MapsByStateGallery extends React.Component {
    constructor(props) {
        super(props);
        const stateName = this.props.stateNames[props.initialState].toLowerCase().replace(' ', '-');
        this.state = {
            selectedStateID: '',
            stateName: stateName,
        };
        this.fetchData();
    }

    fetchData() {
        fetch('/hunting/state_sources_data/')
            .then(response => {
                return response.json();
            })
            .then(myJson => {
                let selectedStateID = myJson.stateIDs.indexOf(this.props.initialState);
                if (selectedStateID === -1) selectedStateID = 0;
                this.setState({
                    ...this.state,
                    ...myJson,
                    selectedStateID: selectedStateID,
                    selectedState: this.props.initialState,
                });
            });
    }

    selectState(event) {
        const stateID = this.state.stateIDs[event.target.value];
        const stateName = this.props.stateNames[stateID].toLowerCase().replace(' ', '-');
        trackAnalytics('Select State', {
            category: 'Commerce',
            currentState: this.state.selectedState,
            nextState: stateName,
            url: window.location.href,
        });
        this.setState({
            selectedStateID: event.target.value,
            selectedState: stateID,
            stateName: stateName,
        });
    }

    onSelectCardClick(source) {
        trackAnalytics('Select Map Source Card', {
            category: 'hunting',
            url: window.location.href,
            source: source.uniqueTilecacheKey,
        });
    }

    render() {
        let stateMenuItems;
        if (this.state.sources) {
            stateMenuItems = this.state.stateIDs.map((stateID, i) => (
                <MenuItem key={i} value={i}>
                    {this.props.stateNames[stateID]} - {this.state.sources[stateID].length}
                </MenuItem>
            ));
        }
        const url = window.location.href;
        const statePage = url.includes(this.state.stateName);
        let titleBlock;
        if (statePage) {
            titleBlock = (
                <h3 className="unit-head" style={{color: '#343a3a'}}>
                    State GMUS, WMAs, Walkins, and More&nbsp;&nbsp;
                </h3>
            );
        } else {
            titleBlock = (
                <h3 className="unit-head" style={{color: '#343a3a'}}>
                    State GMUS, WMAs, Walkins, and More&nbsp;&nbsp;
                    <FormControl>
                        <Select
                            className="hunt-select"
                            disabled={!this.state.sources}
                            value={this.state.selectedStateID}
                            onChange={e => this.selectState(e)}
                            inputProps={{
                                name: 'state',
                                id: 'state',
                            }}
                        >
                            {stateMenuItems}
                        </Select>
                    </FormControl>
                </h3>
            );
        }
        let visibleSourceBlocks;
        if (this.state.sources) {
            visibleSourceBlocks = this.state.sources[this.state.selectedState].map((source, i) => (
                <div key={i} className="col-xs-12 col-md-4">
                    <a
                        // eslint-disable-next-line max-len
                        href={`/hunting/${this.state.stateName}/${source.uniqueTilecacheKey.substr(6)}`}
                        target="_new"
                        onClick={() => this.onSelectCardClick(source)}
                    >
                        <div className="map-container">
                            <img className="map-img" src={source.thumbnail_url} />
                            <img className="preview-button" />
                        </div>
                    </a>
                    <h4 style={{
                        textAlign: 'center',
                        height: 26,
                        overflow: 'hidden',
                        marginBottom: 24
                    }}>
                        <a
                            // eslint-disable-next-line max-len
                            href={`/hunting/${this.state.stateName}/${source.uniqueTilecacheKey.substr(6)}`}
                            target="_new"
                            onClick={() => this.onSelectCardClick(source)}
                        >
                            {source.name_short}
                        </a>
                    </h4>
                </div>
            ));
        }
        return (
            <MuiThemeProvider theme={theme}>
                <div style={{textAlign: 'center'}}>
                    {titleBlock}
                    {visibleSourceBlocks}
                </div>
            </MuiThemeProvider>
        );
    }
}
